import { useEffect } from 'react';
import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';

const prerollDurationVar = createSignal<number | null>(null);

export const usePrerollDuration = () => useSignal(prerollDurationVar);

export const usePrerollDurationWatcher = (stream: MovieStreamFragment | null) => {
    const prerollDurationMs = stream?.streamMeta?.prerollsDuration ?? null;

    useEffect(() => {
        if (prerollDurationMs !== null) {
            prerollDurationVar.set(prerollDurationMs / 1000);
        }
    }, [prerollDurationMs]);
};
